import React, { useState } from "react";
import close from "../../notes-fhir/images/Union (2).svg";
import ModalPopup from "../../../components/newcomponents/ModalPopup";
import { fetchMutation } from "../../../actions";
import { DELETE_CREATE_NOTES } from "../../notes-fhir/actions/notesAct";
import { ShowAlert } from "../../../common/alert";
import { errorToDisplay } from "../../../helper/CommonFuncs";
export const DeleteNote = ({
   title = "Delete Note",
   subtitle = "Are you sure you want to delete this note?\n We won’t delete it from EPIC’s patient’s chart",
   onCancel = () => {},
   noteId = "",
   getNotes,
   isDetailsPage = false,
   oncompleted = () => {},
}) => {
   const [loader, setLoader] = useState(false);
   const onDelete = () => {
      setLoader(true);
      let notesObj = {
         createNotes: { id: noteId, isDisable: true },
      };

      fetchMutation(
         DELETE_CREATE_NOTES,
         notesObj,
         (res) => {
            if (!isDetailsPage) {
               getNotes(false);
            }

            const message = res?.data?.createNotes?.status?.message;
            ShowAlert(message);
            oncompleted();
            setLoader(false);
         },
         (error) => {
            setLoader(false);
            ShowAlert(errorToDisplay(error), "error");
         }
      );
   };
   return (
      <ModalPopup onModalTapped={() => {}}>
         <div className="main-container-epic-delete">
            <img className="image-cross-epic-notes" onClick={onCancel} src={close} alt="cross-button" />
            <div className="title-header-epic-delete">{title}</div>
            <div className="label-subtitle-epic-delete">{subtitle}</div>
            <div className="buttons-containers-epic-delete">
               <button onClick={onCancel} className="button-epic-cancel">
                  Nevermind
               </button>
               <button onClick={onDelete} className="button-epic-delete">
                  {loader ? "Deleting..." : "Delete"}
               </button>
            </div>
         </div>
      </ModalPopup>
   );
};
